module.exports = __webpack_public_path__ + "img/about_bg.3c432593.png";